/**
 * @module Email Component
 */
import React, { PropTypes } from 'react';
import Input from '../input';


/**
 * Built in method validating the email address
 */
function validateEmail(v, onValidation) {
  if (onValidation) {
    fetch(`${__BASE_URL__}/try/validate_email?email=${encodeURIComponent(v)}`)
      .then((res) => {
        if (!res.ok) {
          return onValidation(false);
        }
        return res.json();
      })
      .then(onValidation)
      .catch(() => onValidation(false));
  }
}


/**
 * @type {PureComponent} Email PureComponent
 */
export function Email(props) {
  const {
    onValidation,
    placeholder,
    onChange,
    value,
    valid,
    error,
  } = props;

  return (
    <Input
      onBlur={v => validateEmail(v, onValidation)}
      placeholder={placeholder}
      onChange={onChange}
      value={value || ''}
      error={error}
      validOverwrite={valid}
      type="email"
    />
  );
}


/**
 * Email propTypes
 */
Email.propTypes = {
  onValidation: PropTypes.func,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  valid: PropTypes.bool,
};


/**
 * default export
 */
export default Email;



// WEBPACK FOOTER //
// ./src/components/sign_up/shared/email/index.jsx